import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { compose } from 'recompose'

import { meta, form } from 'helpers/decorators'
import { apiConfiguration, apiContacts } from 'helpers/decorators/api'
import { ConfigKey } from 'containers/forms/configuration'
import { ConfigurationKeySetModal } from 'components/modals'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { Section } from 'components/layout'
import ConfigLoader from 'components/loaders/ConfigLoader/ConfigLoader'

const enhance = compose(
  meta({
    title: 'Customizations',
    intlKey: 'pageTitle.customizations',
    dynamicProp: 'organizations.detail.name'
  }),
  apiConfiguration({
    getValues: [
      CONFIGURATION_KEYS.allowSimplifiedBronze.id,
      CONFIGURATION_KEYS.auCanSignBronze.id,
      CONFIGURATION_KEYS.auCanSignSilver.id,
      CONFIGURATION_KEYS.auCanSignGold.id,
      CONFIGURATION_KEYS.signOffCoord.id,
      CONFIGURATION_KEYS.allowRegApproval.id,
      CONFIGURATION_KEYS.allowDeletePaid.id,
      CONFIGURATION_KEYS.enableAutoMoveAssessedActivity.id,
      CONFIGURATION_KEYS.participantRegistrationParentalConsentElectronically.id,
      CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired.id,
      CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id,
      CONFIGURATION_KEYS.manageAllParticipants.id,
      CONFIGURATION_KEYS.enableEditActivity.id,
      CONFIGURATION_KEYS.enableLogRestriction.id,
      CONFIGURATION_KEYS.isMessagingEnabled.id,
      CONFIGURATION_KEYS.isShowAwardLeaderDetailsAllowed.id,
      CONFIGURATION_KEYS.isBulkLogsEnabled.id,
      CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id,
      CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id,
      CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id,
      CONFIGURATION_KEYS.participantRegSkipPayment.id,
      CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id
    ],
    decoOrganizationId: true
  }),
  form({
    form: 'form-change-config-value'
  }),
  apiContacts({
   active: true
  })
)

class AwardUnitCustomizations extends Component {
  static propTypes = {
    configuration: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    onUpdateConfigKey: PropTypes.func.isRequired,
    onResetConfigKey: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    isConfigUpdating: PropTypes.bool
  }

  state = {
    config: {}
  }

  key = uuid.v1()

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  render() {
    const {
      configuration,
      handleSubmit,
      activeOrganization,
      route,
      contacts
    } = this.props

      const editCustomizationEnabled = get(contacts, 'active.editCustomizationEnabled')

    return (
      <Section
        loading={configuration.loading}
        contentLoader={<ConfigLoader withTabs={false} />}
      >
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.allowSimplifiedBronze.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.auCanSignBronze.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.auCanSignSilver.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.auCanSignGold.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.signOffCoord.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.allowRegApproval.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.enableAutoMoveAssessedActivity.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.allowDeletePaid.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
        <ConfigKey
            config={configuration.values[CONFIGURATION_KEYS.participantRegistrationParentalConsentElectronically.id]}
            activeOrganization={activeOrganization}
            onConfigEdit={this.handleChangeConfig}
            options={{
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
            standalone={false}
        />
        <ConfigKey
            config={configuration.values[CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired.id]}
            activeOrganization={activeOrganization}
            onConfigEdit={this.handleChangeConfig}
            options={{
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
            standalone={false}
        />
        <ConfigKey
            config={configuration.values[CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id]}
            activeOrganization={activeOrganization}
            onConfigEdit={this.handleChangeConfig}
            options={{
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
            standalone={false}
        />
        <ConfigKey
            config={configuration.values[CONFIGURATION_KEYS.manageAllParticipants.id]}
            activeOrganization={activeOrganization}
            onConfigEdit={this.handleChangeConfig}
            options={{
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
            standalone={false}
        />
        <ConfigKey
            config={configuration.values[CONFIGURATION_KEYS.enableLabels.id]}
            activeOrganization={activeOrganization}
            onConfigEdit={this.handleChangeConfig}
            options={{
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
            standalone={false}
        />
          <ConfigKey
              config={configuration.values[CONFIGURATION_KEYS.enableContactLabels.id]}
              activeOrganization={activeOrganization}
              onConfigEdit={this.handleChangeConfig}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              editCustomizationEnabled={editCustomizationEnabled}
              standalone={false}
          />
          <ConfigKey
              config={configuration.values[CONFIGURATION_KEYS.enableOrganizationLabels.id]}
              activeOrganization={activeOrganization}
              onConfigEdit={this.handleChangeConfig}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              editCustomizationEnabled={editCustomizationEnabled}
              standalone={false}
          />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.enableAwardLabels.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />
          <ConfigKey
              config={configuration.values[CONFIGURATION_KEYS.enableEditActivity.id]}
              activeOrganization={activeOrganization}
              onConfigEdit={this.handleChangeConfig}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              editCustomizationEnabled={editCustomizationEnabled}
              standalone={false}
          />
          <ConfigKey
              config={configuration.values[CONFIGURATION_KEYS.enableLogRestriction.id]}
              activeOrganization={activeOrganization}
              onConfigEdit={this.handleChangeConfig}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              editCustomizationEnabled={editCustomizationEnabled}
              standalone={false}
          />
        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isMessagingEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isShowAwardLeaderDetailsAllowed.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />



        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isBulkLogsEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isBulkLogsForBronzeEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isBulkLogsForSilverEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isBulkLogsForGoldEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.participantRegSkipPayment.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigKey
          config={configuration.values[CONFIGURATION_KEYS.isPersonalReflectionFroActivityEnabled.id]}
          activeOrganization={activeOrganization}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          editCustomizationEnabled={editCustomizationEnabled}
          standalone={false}
        />

        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
        />
      </Section>
    )
  }
}

export default enhance(AwardUnitCustomizations)
